import { Route, Routes } from 'react-router-dom';
import { Home } from './Home.js';
import { Layout } from './Layout.js';
import { UploadProvider } from '../features/upload/UploadContext.js';
import { LoginPage } from '../features/auth/LoginPage.js';
import { SignupPage } from '../features/auth/SignupPage.js';
import { RecoveryCodePage } from '../features/auth/RecoveryCodePage.js';
import { RecoverPassphrasePage } from '../features/auth/RecoverPassphrasePage.js';
import { RegenerateRecoveryCodePage } from '../features/auth/RegenerateRecoveryCodePage.js';
import { OAuthCallbackPage } from '../features/auth/OAuthCallbackPage.js';
import { ChangePassphrasePage } from '../features/auth/ChangePassphrasePage.js';
import { ConnectBucketPage } from '../features/bucket/ConnectBucketPage.js';
import { AlbumsListPage } from '../features/albums/AlbumsListPage.js';
import { AlbumDetailPage } from '../features/albums/AlbumDetailPage.js';
import { SearchPage } from '../features/search/SearchPage.js';
import { SharedListPage } from '../features/share/SharedListPage.js';
import { SharedAlbumPage } from '../features/share/SharedAlbumPage.js';
import { TagsListPage } from '../features/tags/TagsListPage.js';
import { TagDetailPage } from '../features/tags/TagDetailPage.js';
import { TopRatedPage } from '../features/rating/TopRatedPage.js';
import { DuplicatesPage } from '../features/duplicates/DuplicatesPage.js';
import { SharedTagsListPage } from '../features/share/SharedTagsListPage.js';
import { SharedTagDetailPage } from '../features/share/SharedTagDetailPage.js';
import { SharedTopRatedPage } from '../features/share/SharedTopRatedPage.js';
import { RequireAuth } from '../auth/RequireAuth.js';

export function App() {
  return (
    <UploadProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route
            index
            element={
              <RequireAuth>
                <Home />
              </RequireAuth>
            }
          />
          <Route path="login" element={<LoginPage />} />
          <Route path="signup" element={<SignupPage />} />
          <Route path="auth/callback" element={<OAuthCallbackPage />} />
          {/* Public: the user cannot derive a master key, so there is no session to guard. */}
          <Route path="recovery" element={<RecoverPassphrasePage />} />
          <Route
            path="recovery-code"
            element={
              <RequireAuth>
                <RecoveryCodePage />
              </RequireAuth>
            }
          />
          <Route
            path="settings/passphrase"
            element={
              <RequireAuth>
                <ChangePassphrasePage />
              </RequireAuth>
            }
          />
          <Route
            path="settings/recovery-code"
            element={
              <RequireAuth>
                <RegenerateRecoveryCodePage />
              </RequireAuth>
            }
          />
          <Route
            path="settings/bucket"
            element={
              <RequireAuth>
                <ConnectBucketPage />
              </RequireAuth>
            }
          />
          <Route
            path="albums"
            element={
              <RequireAuth>
                <AlbumsListPage />
              </RequireAuth>
            }
          />
          <Route
            path="search"
            element={
              <RequireAuth>
                <SearchPage />
              </RequireAuth>
            }
          />
          <Route
            path="albums/:albumId"
            element={
              <RequireAuth>
                <AlbumDetailPage />
              </RequireAuth>
            }
          />
          <Route
            path="albums/:albumId/tags"
            element={
              <RequireAuth>
                <TagsListPage />
              </RequireAuth>
            }
          />
          <Route
            path="albums/:albumId/tags/:tagId"
            element={
              <RequireAuth>
                <TagDetailPage />
              </RequireAuth>
            }
          />
          <Route
            path="albums/:albumId/top-rated"
            element={
              <RequireAuth>
                <TopRatedPage />
              </RequireAuth>
            }
          />
          <Route
            path="albums/:rootId/duplicates"
            element={
              <RequireAuth>
                <DuplicatesPage />
              </RequireAuth>
            }
          />
          <Route
            path="shared"
            element={
              <RequireAuth>
                <SharedListPage />
              </RequireAuth>
            }
          />
          <Route
            path="shared/:rootId"
            element={
              <RequireAuth>
                <SharedAlbumPage />
              </RequireAuth>
            }
          />
          <Route
            path="shared/:rootId/tags"
            element={
              <RequireAuth>
                <SharedTagsListPage />
              </RequireAuth>
            }
          />
          <Route
            path="shared/:rootId/tags/:tagId"
            element={
              <RequireAuth>
                <SharedTagDetailPage />
              </RequireAuth>
            }
          />
          <Route
            path="shared/:rootId/top-rated"
            element={
              <RequireAuth>
                <SharedTopRatedPage />
              </RequireAuth>
            }
          />
          <Route
            path="shared/:rootId/:albumId"
            element={
              <RequireAuth>
                <SharedAlbumPage />
              </RequireAuth>
            }
          />
        </Route>
      </Routes>
    </UploadProvider>
  );
}
